<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <div class="page__onboarding">
        <img src="@/assets/img/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="page__onboarding__logo">
        <img src="./img/airplane.svg" class="page__onboarding__left-img">
        <img src="./img/man.svg" class="page__onboarding__right-img">

        <form class="form--custom" novalidate @submit.prevent="handleSubmit">
          <h2 class="page__onboarding__title" v-html="$t(`${namespace}.title`)" />
          <p class="page__onboarding__text" v-html="$t(`${namespace}.text`)" />

          <v-layout row wrap>
            <v-flex sm12 md6>
              <div @click="tooglePasswordVisibility($event, 'password')">
                <label for="">{{ $t('Views.ResetPassword.newPasswordLabel') }}</label>
                <v-text-field
                  v-model="password"
                  :type="passwordInputType ? 'password' : 'text'"
                  name="password"
                  placeholder="• • • • • • • •"
                  :append-icon="passwordInputType ? 'remove_red_eye' : 'visibility_off'"
                  title=""
                  :disabled="submitted"
                  v-validate="{
                    required: true,
                    hasValidPassword: true,
                    min: 8
                  }"
                  :error-messages="errors.collect($t('Views.ResetPassword.newPassword'))"
                  :data-vv-name="$t('Views.ResetPassword.newPassword')"
                  ref="senha"
                  required
                  flat
                  outline
                  solo
                />
              </div>

              <div @click="tooglePasswordVisibility($event, 'confirmPassword')">
                <label for="">{{ $t('Views.ResetPassword.passwordConfirmLabel') }}</label>
                <v-text-field
                  v-model="passwordConfirm"
                  :type="confirmPasswordInputType ? 'password' : 'text'"
                  name="password"
                  placeholder="• • • • • • • •"
                  :append-icon="confirmPasswordInputType ? 'remove_red_eye' : 'visibility_off'"
                  :disabled="submitted"
                  v-validate="'required|confirmed:senha'"
                  :error-messages="errors.collect($t('Views.ResetPassword.passwordConfirm'))"
                  :data-vv-name="$t('Views.ResetPassword.passwordConfirm')"
                  required
                  flat
                  outline
                  solo
                />
              </div>

              <div class="mb-4">
                <v-btn
                  type="submit"
                  color="warning--gradient"
                  :disabled="submitted"
                  :loading="submitted"
                  round
                  depressed
                  large
                >
                  {{ $t(`${namespace}.buttonLabel`) }}
                </v-btn>
              </div>
            </v-flex>

            <v-flex sm12 md6>
              <PasswordTips class="mb-0 page__onboarding__password-tips" :password="password" />
            </v-flex>
          </v-layout>
        </form>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import userService from '@/services/user'
import Cookies from 'utils/Cookies'
import { SESSION_USER, SESSION_COMPANY, SESSION_HEADERS } from 'utils/constants'
import PasswordTips from 'components/PasswordTips'

export default {
  name: 'OnboardingForm',
  components: {
    PasswordTips
  },
  computed: {
    routeName () {
      return this.$route.name
    },

    token () {
      return this.$route.params.token
    }
  },
  data () {
    return {
      namespace: 'Components.OnboardingForm',
      passwordInputType: true,
      confirmPasswordInputType: true,
      password: null,
      passwordConfirm: null,
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      clearAlert: 'snackbarAlert/clear',
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearUserClaims: 'userClaims/clear'
    }),

    tooglePasswordVisibility (event, type) {
      if (event.target.classList.contains('v-icon')) {
        if (type === 'password') {
          this.passwordInputType = !this.passwordInputType
        }

        if (type === 'confirmPassword') {
          this.confirmPasswordInputType = !this.confirmPasswordInputType
        }
      }
    },

    resetFields () {
      this.password = null
      this.passwordConfirm = null
    },

    resetUserSession () {
      Cookies.set(SESSION_USER, '', 0)
      localStorage.removeItem(SESSION_COMPANY)
      localStorage.removeItem(SESSION_HEADERS)
      this.$store.state.session.status.loggedIn = false
      this.$store.state.session.user = {}
      this.clearUserClaims()
      this.clearSelectedCompany()
    },

    async handleSubmit () {
      const { token, password } = this
      this.clearAlert()

      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) return

        this.submitted = true
        await userService.resetPassword({
          token,
          newPassword: password
        })

        this.submitted = false

        const successMessage = this.routeName === 'FirstAccessLogin'
          ? this.$t(`Views.ResetPassword.firstAccessSuccess`)
          : this.$t(`Views.ResetPassword.resetPasswordSuccess`)
        this.successAlert(successMessage)
        this.$router.push({ name: 'Login' })
      } catch (error) {
        this.submitted = false
        const errorMessage = this.routeName === 'FirstAccessLogin'
          ? this.$t(`Views.ResetPassword.firstAccessError`)
          : this.$t(`Views.ResetPassword.resetPasswordError`)
        this.errorAlert(errorMessage)
        console.log('Error', error)
      }
    }
  },
  created () {
    this.resetUserSession()

    this.$validator.extend('hasValidPassword', {
      getMessage: field => this.$t(`Views.ResetPassword.passwordDefaultError`),
      validate: value => {
        function isValid (text) {
          const rules = {
            charsCount: text.length >= 8,
            lowerCase: /(?=.*[a-z])/.test(text),
            upperCase: /(?=.*[A-Z])/.test(text),
            number: /(?=.*[0-9])/.test(text),
            specialChars: /(?=.*[?!@#$%^&*()_\-+=`~[\]{}:;'<>/\\]+)/.test(text)
          }

          return rules.charsCount && rules.lowerCase && rules.upperCase && rules.number && rules.specialChars
        }

        return isValid(value)
      }
    })
  },
  mounted () {
    if (!this.token) {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page__onboarding {
  background-color: #fff;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  max-width: 683px;
  padding: 30px;
  position: relative;

  @media (min-width: 960px) {
    height: 100vh;
    padding: 30px 92px;
  }

  .form--custom {
    width: 100%;
  }

  .v-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;

    @media (min-width: 960px) {
      width: auto;
    }
  }
}

.page__onboarding__logo {
  display: block;
  margin: 0 auto 30px;
}

.page__onboarding__left-img,
.page__onboarding__right-img {
  display: none;
  position: absolute;
  z-index: 1;

  @media (min-width: 960px) {
    display: inline-block;
  }
}

.page__onboarding__left-img {
  left: -19px;
  top: -28px;
}

.page__onboarding__right-img {
  right: -1px;
  top: 128px;
}

.page__onboarding__title {
  color: $gray-8;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  margin-bottom: 16px;

  span {
    color: $accent;
    display: block;
  }
}

.page__onboarding__text {
  color: $gray-6;
  margin-bottom: 24px;
}
</style>

<style lang="scss">
.page__onboarding__password-tips {
  background-color: $gray-1;
  border-radius: 4px;
  font-size: 12px;
  padding: 16px 6px 15px 19px;

  @media (min-width: 960px) {
    margin-left: 42px;
  }

  .password-tips__title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
  }
}
</style>
